/*
 *  I16DIMADOUCISSEURPRIMCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 15:48:07 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchCapaciteTraitementResine, fetchdiametreAdoucisseurFilterDebit } from '@batical/data/src'
import i18n from '@batical/i18n'
import { RCapaResineSchema_Type, I16DIMADOUCISSEURPRIM_State } from '@batical/types/src'

//TODO IF REQUIREDimport {} from '@batical/types/src';
function I16DIMADOUCISSEURPRIM_docalcul(state: I16DIMADOUCISSEURPRIM_State) {
  state.invalidated = false
  let selectedcpc: RCapaResineSchema_Type = fetchCapaciteTraitementResine(state.cpcTraitementLitreResine_uuid)
  //TODO CALCUL
  if (state.in_thSouhaite === state.in_thEauVille) {
    state.res_cpcTraitementResine = 0
    //should be no 0
    state.res_traitementPrevoir = 0
    state.res_volAvantRegen = 0

    state.res_consoSalt = 0
    state.res_consoEauRenvoie = 0
    state.res_tauxSodiumEau = 0
    state.res_diamAdouc = i18n.t('RAdoucisseurDiametreDebit_NOTFOUND')
  } else if (state.in_volInst === 0) {
    state.res_cpcTraitementResine = 0
    //should be no 0
    state.res_traitementPrevoir = 0
    state.res_volAvantRegen = 0

    state.res_consoSalt = 0
    state.res_consoEauRenvoie = 0
    state.res_tauxSodiumEau = 0
    state.res_diamAdouc = i18n.t('RAdoucisseurDiametreDebit_NOTFOUND')
  } else {
    state.res_cpcTraitementResine = state.in_resineSouhaite * selectedcpc.saltcapacity
    //should be no 0
    state.res_traitementPrevoir = ((state.in_thEauVille - state.in_thSouhaite) * state.in_volInst) / 1000
    state.res_volAvantRegen = (state.res_cpcTraitementResine / (state.in_thEauVille - state.in_thSouhaite)) * 1000
    state.res_consoSalt = (selectedcpc.saltquantity * state.in_resineSouhaite) / 1000
    state.res_consoEauRenvoie = state.res_consoSalt / 0.333
    state.res_tauxSodiumEau = (state.in_thEauVille - state.in_thSouhaite) * 0.0046 * 1000
    state.res_diamAdouc = fetchdiametreAdoucisseurFilterDebit(state.in_debitHPointe)
  }

  return state
}

export default I16DIMADOUCISSEURPRIM_docalcul
